import { render, staticRenderFns } from "./InTkDetail.vue?vue&type=template&id=2243867d&scoped=true&"
import script from "./InTkDetail.vue?vue&type=script&lang=js&"
export * from "./InTkDetail.vue?vue&type=script&lang=js&"
import style0 from "./InTkDetail.vue?vue&type=style&index=0&id=2243867d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2243867d",
  null
  
)

export default component.exports